import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-66587678"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "catalog-card"
};
var _hoisted_2 = {
  class: "catalog-card-header"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "目录", -1);
});

var _hoisted_4 = {
  class: "progress"
};
var _hoisted_5 = {
  class: "catalog-content"
};
var _hoisted_6 = ["onClick", "title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");

  return Object.keys($setup.titles).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("span", null, [_createVNode(_component_font_awesome_icon, {
    icon: ['fas', 'bars-staggered'],
    class: "catalog-icon"
  })]), _hoisted_3]), _createElementVNode("span", _hoisted_4, _toDisplayString($setup.progress), 1)]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.titles, function (title) {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      key: title.id,
      onClick: function onClick($event) {
        return $setup.scrollToView(title.scrollTop);
      },
      class: _normalizeClass(['catalog-item', $setup.currentTitle.id == title.id ? 'active' : 'not-active']),
      style: _normalizeStyle({
        marginLeft: title.level * 20 + 'px'
      }),
      title: title.rawName
    }, _toDisplayString(title.name), 15, _hoisted_6)), [[_vShow, title.isVisible]]);
  }), 128))])])) : _createCommentVNode("", true);
}